import esagono from './images/DecoriPage/patterns/esagono.svg'
import herringBone from './images/DecoriPage/patterns/herringBone.svg'
import largeChalet from './images/DecoriPage/patterns/largeChalet.svg'
import smallChalet from './images/DecoriPage/patterns/smallChalet.svg'
// decori pattern images
import patternHerringBone from './images/DecoriPage/images/herringBonePattern.png'
import patternEsagono from './images/DecoriPage/images/EsagonoPattern.png'
import patternChaletPiccolo from './images/DecoriPage/images/chaletPiccoloPattern.png'
import patternChaletGrande from './images/DecoriPage/images/chaletGrandePattern.png'
// ispirazione page images
import ispirazionePageFirstImage from './images/IspirazionePage/image.png'
import ispirazionePageSecondImage from './images/IspirazionePage/image2.png'
//Homepage bg
import homePageVideo from './images/HomePage/cera_hero.mp4'
// caratteristiche page images
import caratteristichePageFirstImage from './images/CaratteristichePage/first.png'
import caratteristichePageSecondImage from './images/CaratteristichePage/second.png'
import caratteristichePageThirdImage from './images/CaratteristichePage/third.png'
// Dettagli page images
import dettagli1 from './Dettagli/assets/images/dettagli1.jpg'
import dettagli2 from './Dettagli/assets/images/dettagli2.jpg'
// ScaglieDx page images
import formato60x120 from './ScaglieDx/assets/images/formato60x120.png'

import scaglieFumo from './ScaglieDx/assets/images/Cera_Scaglie_Fumo_120x120_small.jpg'
import scaglieFumoZoom from './ScaglieDx/assets/images/Cera_Scaglie_Fumo_120x120.jpg'

import scaglieMulticolore from './ScaglieDx/assets/images/Cera_Scaglie_Multicolore_120x120_small.jpg'
import scaglieMulticoloreZoom from './ScaglieDx/assets/images/Cera_Scaglie_Multicolore_120x120.jpg'

// Scaglie page images
import scaglieIncenso from './Scaglie/assets/images/Cera_Scaglie_Incenso_120x120_small.jpg'
import scaglieIncensoZoom from './Scaglie/assets/images/Cera_Scaglie_Incenso_120x120.jpg'



import calceRibbed from './Scaglie/assets/images/OSMOS_CALCE-RIBBED_60X120_modulo_ribbed.jpg'
import calceRibbedZoom from './Scaglie/assets/images/OSMOS_CALCE-RIBBED_60X120_04.jpg'

import nebbiaRibbed from './Scaglie/assets/images/OSMOS_NEBBIA-RIBBED_60X120_modulo_ribbed.jpg'
import nebbiaRibbedZoom from './Scaglie/assets/images/OSMOS_NEBBIA-RIBBED_60X120_02.jpg'

import tortoraRibbedZoom from './Scaglie/assets/images/OSMOS_TORTORA-RIBBED_60X120_06.jpg'
import tortoraRibbed from './Scaglie/assets/images/OSMOS_TORTORA-RIBBED_60X120_modulo_ribbed.jpg'


// Gallery page images

//import gallery1 from './Gallery/assets/images/7_pav_Osmos_Nebbia-120x120_riv_Nebbia-Ribbed-60x120.jpg'

import gallery1 from './Gallery/assets/images/Refin_Osmos_Tortora 80x80_Out.jpg'


//import gallery2 from './Gallery/assets/images/1_pav_OSMOS CENERE_120x120_riv_OSMOS RUGGINE_60x120_Matt.jpg'

import gallery2 from './Gallery/assets/images/OSMOS_CENERE_120x120_OSMOS RUGGINE_60x120.jpg'


import gallery3 from './Gallery/assets/images/2_REFIN_Osmos_Ruggine-120x120_Matt.jpg'



//import slide1 from './Gallery/assets/images/3_pav_Calce_120×120_ Matt_-_Riv_Trame_Calce_60x120_Matt.jpg'
import slide1 from './Gallery/assets/images/Refin_Osmos_CENERE_60X120_In&Out.jpg'

import slide2 from './Gallery/assets/images/4_Osmos_Trame_Cenere_60x120_Matt.jpg'


//import slide3 from './Gallery/assets/images/5_int_Osmos_Tortora-120x120_Est_Matt_Tortora_120x120_c2grip.jpg'

import slide3 from './Gallery/assets/images/RE_OS_In&Out_Tortora_Eik_Nut_Amb_main_v3_HR.jpg'

import slide4 from './Gallery/assets/images/6_Osmos_Tortora-Ribbed-60x120_Tortora_120x120 Matt.jpg'

// Colori Formati images
import formato60x120_colori from './ColoriFormati/assets/images/formato60x120.svg'
import formato120x120_colori from './ColoriFormati/assets/images/formato120x120.svg'
import formato80x80_colori from './ColoriFormati/assets/images/formato80x80.png'
import formato60x60_colori from './ColoriFormati/assets/images/formato60x60.png'
import formato30x60_colori from './ColoriFormati/assets/images/formato30x60.png'
import formato60x120stripe_colori from './ColoriFormati/assets/images/formato60x120stripe.jpg'
import formato60x120trame_colori from './ColoriFormati/assets/images/formato60x120trame.jpg'



import osmosNebbia60 from './ColoriFormati/assets/images/OSMOS_NEBBIA_C2_GRIP_60X120_04.jpg'
import osmosNebbia120 from './ColoriFormati/assets/images/OSMOS_NEBBIA_C2_GRIP_120X120_03.jpg'
import osmosCenere60 from './ColoriFormati/assets/images/OSMOS_CENERE_C2_GRIP_60X120_07.jpg'
import osmosCenere120 from './ColoriFormati/assets/images/OSMOS_CENERE_C2_GRIP_120X120_07.jpg'
import osmosCalce60 from './ColoriFormati/assets/images/OSMOS_CALCE_C2_GRIP_60X120_01.jpg'
import osmosCalce120 from './ColoriFormati/assets/images/OSMOS_CALCE_C2_GRIP_120X120_02.jpg'
import osmosRuggine60 from './ColoriFormati/assets/images/OSMOS_RUGGINE_C2_GRIP_60X120_16.jpg'
import osmosRuggine120 from './ColoriFormati/assets/images/OSMOS_RUGGINE_C2_GRIP_120X120_01.jpg'
import osmosTortora60 from './ColoriFormati/assets/images/OSMOS_TORTORA_C2_GRIP_60X120_15.jpg'
import osmosTortora120 from './ColoriFormati/assets/images/OSMOS_TORTORA_C2_GRIP_120X120_03.jpg'




import osmosNebbia120t from './ColoriFormati/assets/images/OSMOS_NEBBIA_MATT_120X120_03t.jpg'
import osmosCenere60gript from './ColoriFormati/assets/images/OSMOS_CENERE_C2_GRIP_60X120_07t.jpg'

import osmosCenere60t from './ColoriFormati/assets/images/OSMOS_CENERE-MATT_60X120_11t.jpg'





import osmosCenere120t from './ColoriFormati/assets/images/OSMOS_CENERE_MATT_120X120_04t.jpg'
import osmosCalce120t from './ColoriFormati/assets/images/OSMOS_CALCE_120X1206t.jpg'
import osmosRuggine60t from './ColoriFormati/assets/images/OSMOS_RUGGINE-MATT_60X120_16t.jpg'
import osmosRuggine120t from './ColoriFormati/assets/images/OSMOS_RUGGINE_MATT_120X120_08t.jpg'
import osmosTortora120t from './ColoriFormati/assets/images/OSMOS_TORTORA_MATT_120X120_01t.jpg'
import osmosTrameCalce60t from './ColoriFormati/assets/images/OSMOS_CENERE_TRAME_CALCE_60X120_01t.jpg'
import osmosTrameCenere60t from './ColoriFormati/assets/images/OSMOS_CENERE_TRAME_CALCE_60X120_01t.jpg'
import osmosRibbedTortorat from './ColoriFormati/assets/images/osmos-ribbed-tortorat.jpg'
import osmosRibbedNebbiat from './ColoriFormati/assets/images/osmos-ribbed-nebbia-t.jpg'

import osmosTortora60t from './ColoriFormati/assets/images/OSMOS_TORTORA-MATT_60X120_07t.jpg'

import osmosTortora80t from './ColoriFormati/assets/images/OSMOS_TORTORA_MATT_120X120_01t.jpg'




import heroDesktop from './images/Hero/HERO_Roomboard_desktop.jpg'
import heroMobile from './images/Hero/HERO_Roomboard_mobile.jpg'

import bgMobile from './images/OSMOS_CALCE_120X120_mobile.jpg'
import bgDesktop from './images/OSMOS_CALCE_120X120_desktop.jpg'


export const appConfig = {
    bgDesktop: bgDesktop,
    bgMobile: bgMobile
}

export const HomePageConfig = {
    MenuSideBarElements: [
        'IDEA',
        'DETTAGLI',
        'DECORO',
        'GALLERY',
        'RELIEFS',
        'UN NUOVO LESSICO',
		'LA COLLEZIONE',
        'CONTATTACI'
    ],
    title: 'Osmos',
    secondary: 'matter comes alive',
    heroImageDesktop: heroDesktop,
    heroImageMobile: heroMobile,
    navbar: {
        btnColor: 'white',
        btnBackground: '#154C03',
        btnLabel: 'Contattaci'
    },
}
export const IspirazionePageConfig = {
    id: 'idea',
    title: "L'idea",
    description: "Da un'intuizione alla materia. Grazie alla forza progettuale del nostro laboratorio e alla sensibilità artigiana che guida il nostro approccio, un materiale tradizionalmente neutro come il cemento trova nuova vita come superficie dinamica. Replicato in gres porcellanato, diventa espressione di un design evoluto, capace di rispondere a esigenze estetiche, funzionali e narrative. Una profonda ricerca tecnologica e stilistica accompagna ogni fase del nostro processo creativo, trasformando il risultato in qualcosa che va oltre il semplice rivestimento: è una storia che prende forma.",
    videoId: '1153999933',
    videoColor: '154C03'
}

export const DettagliPageConfig = {
	  id: 'dettagli',
    items: [{
        key: 1,
        image: dettagli1,
        alt: "Stratificazione espressiva",
        title: 'Stratificazione espressiva',
        description: "<p>La <b>forza visiva di Osmos</b> nasce da una <b>grafica multistrato</b> costruita per successive <b>sedimentazioni</b>, che genera una superficie organica, in cui ogni livello aggiunge <b>frammenti visivi</b> e <b>nuove possibilità di lettura</b>. Una materia ibrida, uniforme nell'insieme e sorprendente nei dettagli.</p>",
        ctaLabel: 'Entra nel vivo',
        icon: 'ArrowRight',
        iconPos: 'right',
        slideTo: 1,
    }, {
        key: 2,
        image: dettagli2,
        alt: "I segni del tempo",
        title: 'I segni del tempo',
        description: "<p>Avvicinati e cogli <b>nuove suggestioni a ogni sguardo</b>. Microfratture, inclusioni minerali,  venature marmoree si intrecciano per raccontare un materiale plasmato dal tempo. Le <b>velature di colore</b>, applicate con delicate sovrapposizioni, generano un effetto cloudy che dona <b>profondità e movimento</b> alla superficie. Microgranuli e tracce bianco-grigiastre evocano l'invecchiamento naturale del cemento, restituendo la <b>sensazione</b> di aver assistito a una <b>trasformazione</b>.</p> ",
        ctaLabel: 'Torna alla superficie',
        icon: 'ArrowLeft',
        iconPos: 'left',
        slideTo: 0,
    }]
}


export const ProcessoPageConfig = {
    content: {
        primary: ['La ricerca di un', 'equilibrio autentico'],
        secondary: ['', 'Un mix energico e bilanciato', ', nato dalla collaborazione con una prestigiosa falegnameria del bellunese, specializzata nel recupero di legnami antichi per esclusivi ambienti di lusso. Della ', 'sapienza artigiana alpina', ',  Cortina reinterpreta la ricerca e selezione delle doghe migliori di legni diversi, dando vita a un raffinato equilibrio di essenze. ', 'Per una superficie difficilmente replicabile.']
    },
    video: {
        id: '581728609'
    },
    primaryTextOffset: '300px',
    primaryTextOffsetMobile: '200px',
    subTextOffset: '300px',
    subTextOffsetMobile: '300px'
}

export const ColoriFormatiPageConfig = {


    id: 'un_nuovo_lessico',
    title: 'Dialogo tra colore e materia',
    description: "La <strong>palette di Osmos</strong>, con toni come <strong>Ruggine, Tortora o Calce</strong>, apre nuove prospettive progettuali e introduce un <strong>modo inedito di pensare il cemento</strong>: più caldo, flessibile e contemporaneo. Alle sfumature minerali e terrose si affiancano i toni fumosi e i grigi azzurrati di Cenere e calce, in un equilibrio calibrato tra calore e rigore. L’<strong>ampio ventaglio cromatico</strong> arricchito dalla presenza di <strong>decori e rilievi</strong> che esaltano la matericità della superficie, non è solo una scelta estetica, ma anche concettuale: valorizza la capacità del materiale di dialogare con stili, ambienti e sensibilità progettuali diverse.",
    formatsTitle: 'Disponibile nei formati',
    discoverFormatsLabel: 'Scopri i formati',
    elements: [
    { key: 'nebbia', title: 'Nebbia', description: 'Un gris clair aux tons fumés neutres, avec un effet ombré et un voile délicat. Il apporte de la douceur aux surfaces.', image: osmosNebbia120, imageMobile: osmosNebbia60, formati: [
    { key: 'nebbia_120x120', image: formato120x120_colori, title: '120x120', description: 'Matt<br>C2 grip' },
    { key: 'nebbia_60x120', image: formato60x120_colori, title: '60x120', description: 'Matt<br>C2 grip' },
    { key: 'nebbia_80x80', image: formato80x80_colori, title: '80x80', description: 'Matt' },
    { key: 'nebbia_60x60', image: formato60x60_colori, title: '60x60', description: 'Matt' },
    { key: 'nebbia_30x60', image: formato30x60_colori, title: '30x60', description: 'Matt' },
    { key: 'nebbia_reliefs_60x120', image: formato60x120stripe_colori, title: 'Reliefs 60x120', description: 'Ribbed' },
   
    ] 
},
    { key: 'cenere', title: 'Cenere', description: 'Un gris moyen intense, uniforme et marqué, qui souligne avec précision les surfaces et les volumes.', image: osmosCenere120, imageMobile: osmosCenere60, formati: [
    { key: 'cenere_120x120', image: formato120x120_colori, title: '120x120', description: 'Matt<br>C2 grip' },
    { key: 'cenere_60x120', image: formato60x120_colori, title: '60x120', description: 'Matt<br>C2 grip' },
    { key: 'cenere_80x80', image: formato80x80_colori, title: '80x80', description: 'Matt<br>OUT 2.0' },
    { key: 'cenere_60x60', image: formato60x60_colori, title: '60x60', description: 'Matt' },
    { key: 'cenere_30x60', image: formato30x60_colori, title: '30x60', description: 'Matt' },
     { key: 'cener_decoro_60x120', image: formato60x120trame_colori, title: 'Decoro 60x120', description: 'Trame' },
    ] 
},
    { key: 'calce', title: 'Calce', description: 'Légère et délicate, elle crée une surface homogène et propre qui amplifie la luminosité des espaces.', image: osmosCalce120, imageMobile: osmosCalce60, formati: [
    { key: 'calce_120x120', image: formato120x120_colori, title: '120x120', description: 'Matt<br>C2 grip' },
    { key: 'calce_60x120', image: formato60x120_colori, title: '60x120', description: 'Matt<br>C2 grip' },
    { key: 'calce_80x80', image: formato80x80_colori, title: '80x80', description: 'Matt' },
    { key: 'calce_60x60', image: formato60x60_colori, title: '60x60', description: 'Matt' },
    { key: 'calce_30x60', image: formato30x60_colori, title: '30x60', description: 'Matt' },
    { key: 'calce_reliefs_60x120', image: formato60x120stripe_colori, title: 'Reliefs 60x120', description: 'Ribbed' },
    { key: 'calce_decoro_60x120', image: formato60x120trame_colori, title: 'Decoro 60x120', description: 'Trame' },
    ] 
},
    { key: 'ruggine', title: 'Ruggine', description: "Une teinte chaude et terreuse inspirée des couleurs de l'acier corten. Elle accentue l'effet vieilli et la profondeur du matériau.", image: osmosRuggine120, imageMobile: osmosRuggine60, formati: [
    { key: 'ruggine_120x120', image: formato120x120_colori, title: '120x120', description: 'Matt<br>C2 grip' },
    { key: 'ruggine_60x120', image: formato60x120_colori, title: '60x120', description: 'Matt<br>C2 grip' },
    { key: 'ruggine_80x80', image: formato80x80_colori, title: '80x80', description: 'Matt<br>OUT 2.0' },
    { key: 'ruggine_60x60', image: formato60x60_colori, title: '60x60', description: 'Matt' },
    { key: 'ruggine_30x60', image: formato30x60_colori, title: '30x60', description: 'Matt' },
     { key: 'ruggine_decoro_60x120', image: formato60x120trame_colori, title: 'Decoro 60x120', description: 'Trame' },
    ]  },
    { key: 'tortora', title: 'Tortora', description: 'Une couleur neutre, chaleureuse et enveloppante, idéale pour créer des ambiances élégantes et sobres.', image: osmosTortora120, imageMobile: osmosTortora60, formati: [
    { key: 'tortora_120x120', image: formato120x120_colori, title: '120x120', description: 'Matt<br>C2 grip' },
    { key: 'tortora_60x120', image: formato60x120_colori, title: '60x120', description: 'Matt<br>C2 grip' },
    { key: 'tortora_80x80', image: formato80x80_colori, title: '80x80', description: 'Matt<br>OUT 2.0' },
    { key: 'tortora_60x60', image: formato60x60_colori, title: '60x60', description: 'Matt' },
    { key: 'tortora_30x60', image: formato30x60_colori, title: '30x60', description: 'Matt' },
    { key: 'tortora_reliefs_60x120', image: formato60x120stripe_colori, title: 'Reliefs 60x120', description: 'Ribbed' },
   
    ]  
	},
  ]
}

export const CaratteristichePageConfig = {
    firstContainer: {
        image: caratteristichePageFirstImage,
        content: {
            primary: 'Quando i particolari diventano protagonisti',
            secondary: [' Ti sei mai fermato a osservare tutte le ', 'venature del grès porcellanato', '? In Cortina le più marcate del tenero legno di abete seguono quelle fitte del larice per incontrare i nodi e le cromie tipiche del pino.'],
            tertiary: ['Le ', 'sfumature uniche e irripetibili', ' di ogni lastra Cortina raccontano la provenienza ormai così rara e preziosa delle doghe originali, colorate da Sole e pioggia in oltre 40-70 anni di posa fra baite e antichi fienili.']
        },
        imageOffset: '300px',
        imageOffsetMobile: '700px',
        primaryTextOffset: '350px',
        primaryTextOffsetMobile: '300px',
        subTextOffset: '400px',
        subTextOffsetMobile: '350px'
    },
    secondContainer: {
        image: caratteristichePageSecondImage,
        content: {
            primary: 'L’armonia tra struttura e segni artigianali',
            secondary: ['Calore e struttura esaltano la ', 'potenza materica', ' di Cortina, dal grande impatto visivo e così piacevole e naturale al tatto. Un’esperienza autentica da toccare con mano.'],
            tertiary: ['Ripercorri le ', 'venature del legno', ', arricchite dai ', 'segni artigianali del taglio sega', ': incisioni irregolari che richiamano le antiche lavorazioni della falegnameria tradizionale. ']
        },
        imageOffset: '300px',
        imageOffsetMobile: '500px',
        primaryTextOffset: '300px',
        primaryTextOffsetMobile: '250px',
        subTextOffset: '350px',
        subTextOffsetMobile: '300px'
    },
    thirdContainer: {
        image: caratteristichePageThirdImage,
        content: {
            primary: 'Molto più di un’estetica ricercata',
            secondary: ['Una collezione in cui l’', 'eleganza del legno ', 'non rinuncia alla ', 'resistenza senza tempo ', 'del grès porcellanato, portando la sua atmosfera confortevole anche in ambienti esposti a forte usura e calpestio.'],
            tertiary: ['Una finitura dal ', 'gusto ecosostenibile', ', dove la ricercatezza si traduce in attenzione all’ambiente, fondendo etica ed estetica per rendere disponibile un prodotto raro, dalla resa non ottenibile con materiali naturali.']
        },
        imageOffset: '300px',
        imageOffsetMobile: '450px',
        primaryTextOffset: '250px',
        primaryTextOffsetMobile: '200px',
        subTextOffset: '300px',
        subTextOffsetMobile: '250px'
    }
}

export const DecoriPageConfig = {
    content: {
        primary: 'Quattro decori. Infinite possibilità.',
        secondary: ['Dai un tocco in più ai tuoi ambienti con i decori. Volumi e linee geometriche disegnano uno stile dal forte impatto visivo. Listelli, esagoni o spine di pesce: ogni decoro è disponibile in tutti i colori della collezione per creare atmosfere e sensazioni diverse.']
    },
    mobileContent: {
        primary: 'I quattro decori di Cortina',
        secondary: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
    },
    patterns: [
        {
            name: 'Chalet',
            firstDimension: '15x90 cm',
            secondDimension: '6"x36"',
            src: largeChalet,
            content: 'Il calore di un ambiente che diventa rifugio accogliente. L’eleganza rigenerante degli elementi naturali si ispira al fascino degli chalet: la tradizionale grafica mossa riempie gli interni di charm.'
        
            },
        {
            name: 'Chalet',
            firstDimension: '12x75 cm',
            secondDimension: '5"x30"',
            src: smallChalet,
            content: 'Un formato più piccolo per un effetto ancora più dinamico, in grado di portare la viva espressività degli elementi naturali fra le pareti di una stanza,  trasformandola.'
        },        
        {
            name: 'Esagono',
            firstDimension: '25x21,6 cm',
            secondDimension: '10"x8<sup>1/2</sup>"',
            src: esagono,
            content: 'La bellezza inconsueta dei giochi geometrici. Il decoro Esagono dona al calore tipico del legno un sorprendente gusto internazionale e moderno. Per un’atmosfera di precisa originalità.'
        },
        {
            name: 'Herringbone',
            firstDimension: '36,2x41x2 cm',
            secondDimension: '14<sup>1/8</sup>"x16<sup>1/8</sup>"',
            src: herringBone,
            content: 'La tradizione italiana trova nuova espressione. Herringbone trasforma il tipico pavimento a doghe piccole e diagonali in un decoro versatile, che esalta la combinazione di essenze e porta il suo fascino dinamico anche a rivestimento.'
        },
        
        
    ],
    patternImages: [
        patternChaletGrande,
        patternChaletPiccolo,
        patternEsagono,
        patternHerringBone,      
        
    ],
    primaryTextOffset: '450px',
    primaryTextOffsetMobile: '100px',
    subTextOffset: '500px',
    subTextOffsetMobile: '100px'
}

export const FormConfiguration = {
    paesi: [
        'Italia',
        'Albania',
        'Germany',
        'France',
        'Inghilterra'
    ],
    citta: [
        'Milano',
        'Torino',
        'Roma',
        'Napoli'
    ],
    cap: [
        '20100',
        '12838',
        '123123',
        '1231212'
    ],
    infoSulPrivacy: 'http://wikipedia.it'
}

export const FooterLinks = {
    sedeLegale: '/location',
    showroom: '/location'
}

export const SocialLinks = {
    facebook: 'https://facebook.com',
    linkedin: 'linkedin.com',
    twitter: 'twitter.com',
    instagram: 'instagram.com',
    pinterest: 'pinterest.com',
    youtube: 'youtube.com'
}

export const CollezioniPageConfig = {
	  id: 'la_collezione',
    title: 'La Collezione',
    videoId: '1148684303'
}

export const CtaConfig = {
    title: 'Immergiti nell’universo Osmos',
    collectionButtonLabel: 'Vai alla scheda collezione',
    catalogButtonLabel: 'Scarica il catalogo',
    collectionButtonHref: 'https://www.refin.it/collezioni/osmos/'
}

export const PhotoModalConfig = {
    zoomInText: 'Clicca due volte per ingrandire',
    dragToExploreText: 'Trascina il cursore per esplorare'
}

export const ScaglieDxPageConfig = {
    id: 'decoro',
    intro: 'Decoro',
    titolo: 'Trame, sotto la pelle di Osmos',
    descrizione: 'Un reticolato irregolare riaffiora come una trama sommersa: è l’anima metallica del cemento che, segnata dall’usura e deformata dal tempo, torna a galla ancora pulsante. La tecnologia adottata permette di creare tridimensionalità in superficie apportando piccole quantità di materiale: scolpendo la ceramica con rilievi autentici, leggermente ruvidi al tatto. Trame si presta anche alla posa a pavimento.',
    images: [
      { label: 'ROTATE', src: scaglieFumo, srcZoomed: scaglieFumoZoom, videoId: '1119343652' },
      { label: 'ZOOM', src: scaglieMulticolore, srcZoomed: scaglieMulticoloreZoom, videoId: '1119343688'},
    ],
    formati: {
      titolo: 'Disponibile nel formato',
      items: [
        { src: formato60x120, titolo: 'Trame 60x120', sottotitolo: '24"x48"' },
      ]
    },
    videoColor: '154C03'
}

export const ScagliePageConfig = {
    id: 'reliefs',
    intro: 'RELIEFS 3D WALL COVERINGS',
    titolo: 'Ribbed: geometrie sensibili',
    descrizione: 'La rigatura incisa a distanze irregolari esalta la profondità della grafica e dialoga in maniera armonica con la luce. La texture, misurata e continua, interpreta al meglio la forza espressiva del gres, creando una tridimensionalità materia che amplifica il valore sensoriale del prodotto. Estensione naturale di Osmos, riveste le pareti con un linguaggio sobrio e sensibile.',
    images: [
      { label: 'NEBBIA', src: nebbiaRibbed, srcZoomed: nebbiaRibbedZoom },
      { label: 'CALCE', src: calceRibbed, srcZoomed: calceRibbedZoom },
      { label: 'TORTORA', src: tortoraRibbed, srcZoomed: tortoraRibbedZoom },
    ],
    formati: {
      titolo: 'Disponibile nel formato',
      items: [
        { src: formato60x120, titolo: 'Reliefs 60x120', sottotitolo: '24"x48"' },
      ]
    }
}



export const GalleryPageConfig = {
    id: 'gallery',
    title: 'Versatilità progettuale e identità autentica',
    description: "<p>La collezione offre molteplici opportunità d'uso: si presta a residenze moderne e materiche, spazi contract come boutique hotel, showroom e locali contemporanei. Ideali per uffici creativi e contesti pubblici, si integra perfettamente in ambienti minimalisti, industriali e brutalisti, garantendo superfici dal forte carattere.</p>",
     items: [
     { 
      key: 1, 
      image: gallery2, 
      points: [
        { 
          key: 11, 
          x: 50, 
          y: 85, 
          yside: 'top',
          thumb: osmosCenere120t,
          description: "Cenere", 
          variant: "<b>120x120</b> 48”x48” R <span>Matt</span>",
          variantdl: "120x120"
        },
        { 
          key: 12, 
          x: 80, 
          y: 45,
          thumb: osmosRuggine60t,
          description: "Ruggine", 
          variant: "<b>60x120</b> 24”x48” R <br><span>Matt</span>",
          variantdl: "60x120"
        },
      ]
    }, 
        { 
      key: 2, 
      image: gallery3, 
      points: [
        { 
          key: 21, 
          x: 50, 
          y: 50, 
          yside: 'top',
          thumb: osmosRuggine120t,
          description: "Ruggine", 
          variant: "<b>120x120</b> 48”x48” R <br><span>Matt</span>",
          variantdl: "120x120"
        }
      ]
    }, 

{ 
	key:3, 
	image: slide1, 
	points: [
		{ 
			key: 31, 
			x: 43, 
			y: 46,
			xside: 'right',
			thumb: osmosCenere60t,
			description: "Cenere", 
			variant: "<b>60x120</b> 24”x48” R <br><span>Matt</span>",
			variantdl: "60x120"
		},
		{ 
			key: 32, 
			x: 35, 
			y: 85,
			yside: 'top',
			thumb: osmosCenere60gript,
			description: "Cenere", 
			variant: "<b>60x120</b> 24”x48” R <br><span>C2Grip</span>",
			variantdl: "60x120"
		},
	]
},


    // { 
    //   key:3, 
    //   image: slide1, 
    //   points: [
    //     { 
    //       key: 31, 
    //       x: 15, 
    //       y: 50,
    //       xside: 'right',
    //       thumb: osmosTrameCalce60t,
    //       description: "Trame Calce", 
    //       variant: "<b>60x120</b> 24”x48” R <br><span>Matt</span>",
    //       variantdl: "60x120"
    //     },
    //     { 
    //       key: 32, 
    //       x: 80, 
    //       y: 88,
    //       yside: 'top',
    //       thumb: osmosCalce120t,
    //       description: "Calce", 
    //       variant: "<b>120x120</b> 48”x48” R <br><span>C2Grip</span>",
    //       variantdl: "120x120"
    //     },
    //   ]
    // },

    { 
      key: 4, 
      image: slide2, 
      points: [
        { 
          key: 41, 
          x: 25,
          y: 25,
          yside: 'bottom',
          xside: 'right',
          thumb: osmosTrameCenere60t,
          description: "Trame Cenere", 
          variant: "<b>60x120</b> 24”x48” R <br><span>Matt</span>",
          variantdl: "60x120"
        },
      ]
    }, { 
      key: 5, 
      image: slide3, 
      points: [
        {
          key: 51, 
          x: 35,
          y: 80,
          yside: 'top',
          thumb: osmosTortora120t,
          description: "Tortora", 
          variant: "<b>120x120</b> 48”x48” R <br><span>C2Grip</span>",
          variantdl: "120x120"
        },
        {
          key: 52,
          yside: 'top',
          xside: 'right',
          x: 65,
          y: 80,
          thumb: osmosTortora120t,
          description: "Tortora", 
          variant: "<b>120x120</b> 48”x48” R <br><span>Matt</span>",
          variantdl: "120x120"
        }
      ]
    },
    { 
      key: 6, 
      image: slide4, 
      points: [ 
        { 
          key: 61, 
          x: 25,
          y: 30, 
          xside: 'right',
          thumb: osmosRibbedTortorat,
          description: "Ribbed Tortora", 
          variant: "<b>60x120</b> 24”x48” R <br><span>Ribbed</span>",
          variantdl: "60x120"
        },
        { 
          key: 62, 
          x: 25,
          y: 80, 
          xside: 'right',
          thumb: osmosTortora120t,
          description: "Tortora", 
          variant: "<b>120x120</b> 48”x48” R <br><span>Matt</span>",
          variantdl: "60x120"
        }
      ]
    },
    { 
      key: 7, 
      image: gallery1, 
      points: [ 
        { 
          key: 71, 
          x: 44,
          y: 75,
          thumb: osmosTortora60t,
          description: "Osmos Tortora", 
          variant: "<b>60x120</b> 24”x48” R <br><span>Matt</span>",
          variantdl: "60x120"
        },
        {
          key: 72, 
          x: 90, 
          y: 35,
          thumb: osmosTortora80t,
          description: "Osmos Tortora", 
          variant: "<b>80x80</b> 32”x32” R <br><span>OUT 2.0</span>",
          variantdl: "80x80"
        },
      ]
    },
  ]
}